import { TYPES } from './types'
import { SagaIterator } from 'redux-saga'
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeEvery
} from 'redux-saga/effects'
import * as navbarController from 'controller/navbarController'
import * as navbarActions from 'store/modules/navbar/actions'
import * as loadingActions from 'store/modules/loading/actions'
import * as loginActions from 'store/modules/login/actions'
import { NAVBAR } from './types'
import { ApplicationState } from 'store'
import { handlerError } from 'util/handlerError'
import { toast } from 'react-toastify'
import { LOGIN, TYPES as LOGIN_TYPES } from '../login/types'

function* atualizaToken(): SagaIterator {
  const { token, usuarioSelected }: NAVBAR = yield select(
    (state: ApplicationState) => state.navbar
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(navbarController.atualizaToken, token, usuarioSelected)
    yield put(navbarActions.cleanToken())
    yield put(navbarActions.cleanUsuarioSelected())
    toast.success('Token atualizado com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getUsuariosInstituicao(): SagaIterator {
  try {
    const response = yield call(navbarController.getUsuariosInstituicao)
    yield put(navbarActions.setUsuariosInstituicao(response?.data?.content))
  } catch (error) {
    handlerError(error)
  }
}
function* confirmarAcaoAssociarDesassociar(): SagaIterator {
  try {
    const { acaoModalAssociar, ramalAssociado, statusAgente }: NAVBAR =
      yield select((state: ApplicationState) => state.navbar)
    yield put(loadingActions.setLoading(true))
    if (!ramalAssociado.associado && acaoModalAssociar === 'associar') {
      yield call(navbarController.associarRamal)
    } else {
      if (statusAgente.pausado) {
        yield call(navbarController.despausarAgente)
        yield put(
          navbarActions.setStatusAgenteCronometro({
            agente: '',
            pausado: false,
            horarioPausa: null
          })
        )
      }
      yield call(navbarController.desassociarRamal)
    }
    yield put(navbarActions.toggleModalAssociarDesassociar(false))
    yield put(navbarActions.getRamalAssociadoSaga())
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getRamalAssociado(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield put(loginActions.getValidaParametrosSaga())
    yield take(LOGIN_TYPES.GET_VALIDA_PARAMETROS_SUCCESS)
    const { parametrosValidos }: LOGIN = yield select(
      (state: ApplicationState) => state.login
    )
    if (parametrosValidos) {
      const response = yield call(navbarController.getRamalAssociado)
      yield put(
        navbarActions.setRamalAssociado(
          response?.data?.content || {
            empresa: '',
            ramal: '',
            associado: false
          }
        )
      )
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* getMotivosPausas(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield put(loginActions.getValidaParametrosSaga())
    yield take(LOGIN_TYPES.GET_VALIDA_PARAMETROS_SUCCESS)
    const { parametrosValidos }: LOGIN = yield select(
      (state: ApplicationState) => state.login
    )
    if (parametrosValidos) {
      const response = yield call(navbarController.getMotivosPausa)
      if (
        Array.isArray(response?.data?.content) &&
        response.data.content.length > 0
      ) {
        yield put(navbarActions.setMotivosPausas(response?.data?.content))
      } else {
        yield put(navbarActions.setMotivosPausas([]))
      }
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* confirmarPausaDeAgente(): SagaIterator {
  try {
    const { acaoModalPausarAgente, motivoPausaId, statusAgente }: NAVBAR =
      yield select((state: ApplicationState) => state.navbar)
    yield put(loadingActions.setLoading(true))

    if (!statusAgente.pausado && acaoModalPausarAgente === 'pausar') {
      if (!motivoPausaId) {
        toast.error('Motivo da pausa não selecionado!')
        return
      }
      yield call(navbarController.pausarAgente, motivoPausaId)
    } else {
      yield call(navbarController.despausarAgente)
    }
    yield put(navbarActions.toggleModalPausarAgente(false))
    yield put(navbarActions.cleanMotivosPausa())
    yield put(navbarActions.getStatusAgenteSaga())
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* getStausAgente(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield put(loginActions.getValidaParametrosSaga())
    yield take(LOGIN_TYPES.GET_VALIDA_PARAMETROS_SUCCESS)
    const { parametrosValidos }: LOGIN = yield select(
      (state: ApplicationState) => state.login
    )
    if (parametrosValidos) {
      const response = yield call(navbarController.getStatusAgente)
      yield put(navbarActions.setStatusAgente(response?.data?.content))
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put({ type: TYPES.GET_STATUS_AGENTE_SUCCESS })
    yield put(loadingActions.setLoading(false))
  }
}

function* despausarAgente(): SagaIterator {
  try {
    yield call(navbarController.despausarAgente)
    yield put(
      navbarActions.setStatusAgenteCronometro({
        agente: '',
        pausado: false,
        horarioPausa: null
      })
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put({ type: TYPES.DESPAUSAR_AGENTE_SUCCESS })
    yield put(loadingActions.setLoading(false))
  }
}

export function* watchAtualizaToken() {
  yield takeEvery(TYPES.ATUALIZA_TOKEN_SAGA, atualizaToken)
}

export function* watchGetUsuariosInstituicao() {
  yield takeEvery(TYPES.GET_USUARIOS_INSTITUICAO_SAGA, getUsuariosInstituicao)
}
export function* watchConfirmarAcaoAssociarDesassociar() {
  yield takeEvery(
    TYPES.CONFIRMAR_ACAO_ASSOCIAR_DESASSOCIAR_SAGA,
    confirmarAcaoAssociarDesassociar
  )
}
export function* watchGetRamalAssociado() {
  yield takeEvery(TYPES.GET_RAMAL_ASSOCIADO_SAGA, getRamalAssociado)
}
export function* watchGetMotivosPausa() {
  yield takeEvery(TYPES.GET_MOTIVOS_PAUSA_SAGA, getMotivosPausas)
}
export function* watchConfirmarAcaoAgentePausar() {
  yield takeEvery(
    TYPES.CONFIRMAR_ACAO_PAUSAR_AGENTE_SAGA,
    confirmarPausaDeAgente
  )
}
export function* watchGetStatusAgente() {
  yield takeEvery(TYPES.GET_STATUS_AGENTE_SAGA, getStausAgente)
}

export function* watchDespausar() {
  yield takeEvery(TYPES.DESPAUSAR_AGENTE_SAGA, despausarAgente)
}
function* navbarSaga() {
  yield all([
    fork(watchAtualizaToken),
    fork(watchGetUsuariosInstituicao),
    fork(watchConfirmarAcaoAssociarDesassociar),
    fork(watchGetRamalAssociado),
    fork(watchGetMotivosPausa),
    fork(watchConfirmarAcaoAgentePausar),
    fork(watchGetStatusAgente),
    fork(watchDespausar)
  ])
}

export default navbarSaga
